import ServiceSearch from "./ServiceSearch";

export { ServiceSearch };

export default { ServiceSearch };
